// import Request from './Request';

export default {
  // component: Request,
  priority: 98,
  path: 'box',
  permissions: ['RequestsMenu/Box/',"isNotAdmin",],// 'isNotAdmin'], //['SentMenu', 'ReceivedMenu', 'DraftMenu'],
  name: app.translate('routes.home.requests.Box'),
  icon: 'dropbox',
  drawer: true,
};


